import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import moment from 'moment';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';
import { LoggerService } from '../../../services/logger.service';

@Component({
  selector: 'app-post-lesson',
  templateUrl: './post-lesson.component.html',
  styleUrls: ['./post-lesson.component.css']
})
export class PostLessonComponent extends BaseDialogComponent implements OnInit {

  override entityId = this._injectedDialogData?.['data']?.['entityID'];

  override ngAfterContentInit(): void {
    this.onSubmit(this.f);
  }

  override onSubmit(form: NgForm) {
    this.displayProgressSpinner(true);
    let params: { parameter: any, value: any }[] = [];

    // Add params the endpoint is expecting.
    params = [
      { parameter: 'selectedStatus[' + this._injectedDialogData?.['data']?.['eventData']['studentsDashboardLinks'][0]?.attendees_id + ']', value: 59 },
      { parameter: 'dateTime', value: moment().format('YYYY-MM-DD[T]HH:mm:ss') }, // 2022-02-21T19:59:20
      { parameter: 'eventId', value: this.entityId },
    ];

    this._drupalRESTService.httpGET('/api_rest/v1/updateStatus', params)
      .subscribe(data => {
        this.displayProgressSpinner(false);
        LoggerService.log(data)
        if (data?.['success']) {
          this._dialog.closeAll();
        } else {
          // Handle error response
          this.errorMessage = data?.['message'] || "There was a problem posting this lesson.";
        }
      },
        error => {
          this.displayProgressSpinner(false);
          // Extract message from error response if available
          this.errorMessage = error?.error?.message || "There was a problem posting this lesson.";
          LoggerService.error('Post lesson error:', error);
        });
  }

}
